import React, { useEffect } from 'react';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from '../../../../services/graphql.service';
import { setFirstClick } from '../../../../helpers/firstClick';
import { ASSET_PATH } from '../../../../consts/env.consts';
import CitySingleSSR from '../../../../pages/seo-city-sub-single';
import '../../../../../styles.scss';
import '../../../../helpers/firebase';

// eslint-disable-next-line no-undef
__webpack_public_path__ = ASSET_PATH;

const SeoCitySingle =
    ({ city }, { pathname }) =>
    () => {
        useEffect(() => {
            setFirstClick();
        }, []);

        return (
            <ApolloProvider client={apolloClient}>
                <CitySingleSSR {...{ city, pathname }} />
            </ApolloProvider>
        );
    };

export default SeoCitySingle;
